<div class="zones-page">
  <!-- Toolbar -->
  <div class="toolbar">
    <div class="search-box">
      <i class="bx bx-search"></i>
      <input
        type="text"
        placeholder="Search Zones..."
        [value]="searchTerm"
        (input)="onSearch($event)"
      />
    </div>

    <div class="right-controls">
      <div class="fnf-segmented fnf-segmented--compact" role="tablist">
        <button
          type="button"
          class="fnf-segment"
          [class.fnf-segment--active]="viewMode === 'list'"
          (click)="setViewMode('list')"
        >
          <i class="bx bx-list-ul" aria-hidden="true"></i> List
        </button>
        <button
          type="button"
          class="fnf-segment"
          [class.fnf-segment--active]="viewMode === 'grid'"
          (click)="setViewMode('grid')"
        >
          <i class="bx bx-grid-alt" aria-hidden="true"></i> Grid
        </button>
      </div>

      <button type="button" class="new-btn" (click)="addNewZone()">
        <i class="bx bx-plus"></i>
        New Zone
      </button>
    </div>
  </div>

  @if (displayLoading) {
    <div
      class="d-flex flex-column align-items-center justify-content-center common-loading-container"
    >
      <div class="w-25 text-center">
        <img class="common-loading" src="assets/menu_loading.gif" alt="common loading" />
        <p class="common-loading-text">Loading zones, please wait...</p>
      </div>
    </div>
  } @else if (visibleZones.length > 0) {
    @if (viewMode === 'grid') {
      <!-- Card grid -->
      <div class="zone-grid">
        @for (zone of visibleZones; track zone) {
          <div class="zone-card">
            <div class="zone-card-header">
              <span class="zone-name">{{ zone.zone_name | titlecase }}</span>
              <div class="card-actions">
                <button
                  type="button"
                  class="icon-btn edit"
                  title="Edit Zone"
                  (click)="$event.stopPropagation(); addNewZone(zone)"
                >
                  <i class="bx bx-edit-alt"></i>
                </button>
                <button
                  type="button"
                  class="icon-btn delete"
                  title="Delete Zone"
                  (click)="$event.stopPropagation(); deleteZoneConfirm(zone)"
                >
                  <i class="bx bx-trash"></i>
                </button>
              </div>
            </div>

            <div class="meta-group">
              <div class="info-row">
                <span class="info-label">Max Capacity</span>
                <span class="info-value">{{ zone.capacity }} guests</span>
              </div>
              <div class="info-row">
                <span class="info-label">Floor No</span>
                <span class="info-value">{{
                  zone.floor != null ? 'Floor ' + zone.floor : '-'
                }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">Wheelchair Accessible</span>
                @if (zone.wheelchair_accessibility) {
                  <span class="state-pill yes">&#10003; Yes</span>
                } @else {
                  <span class="state-pill no">&#10005; No</span>
                }
              </div>
            </div>
          </div>
        }
      </div>
    } @else {
      <!-- Table view -->
      <div class="list-card">
        <div class="list-head list-row">
          <span class="col-name">Zone Name</span>
          <span class="col-capacity">Max Capacity</span>
          <span class="col-floor">Floor No</span>
          <span class="col-access">Wheelchair Accessible</span>
          <span class="col-actions">Actions</span>
        </div>

        @for (zone of visibleZones; track zone) {
          <div class="list-row">
            <span class="col-name zone-name">{{ zone.zone_name | titlecase }}</span>
            <span class="col-capacity">{{ zone.capacity }} guests</span>
            <span class="col-floor">{{ zone.floor != null ? 'Floor ' + zone.floor : '-' }}</span>
            <span class="col-access">
              @if (zone.wheelchair_accessibility) {
                <span class="state-pill yes">&#10003; Yes</span>
              } @else {
                <span class="state-pill no">&#10005; No</span>
              }
            </span>
            <span class="col-actions row-actions">
              <i
                class="bx bx-edit-alt action-icon edit"
                title="Edit Zone"
                (click)="$event.stopPropagation(); addNewZone(zone)"
              ></i>
              <i
                class="bx bx-trash action-icon delete"
                title="Delete Zone"
                (click)="$event.stopPropagation(); deleteZoneConfirm(zone)"
              ></i>
            </span>
          </div>
        }

        <div class="list-footer">
          <span
            >Showing {{ visibleZones.length }}
            {{ visibleZones.length === 1 ? 'zone' : 'zones' }}</span
          >
        </div>
      </div>
    }
  } @else if (zones?.length > 0) {
    <div
      class="d-flex flex-column align-items-center justify-content-center common-empty-container"
    >
      <img src="assets/no-orders-yet.svg" alt="No matches" class="common-empty-img mb-3" />
      <p class="common-empty-header">No Matching Zones</p>
      <p class="common-empty-sub-text">Try a different search term.</p>
    </div>
  } @else {
    <div
      class="d-flex flex-column align-items-center justify-content-center common-empty-container"
    >
      <img src="assets/no-orders-yet.svg" alt="No Zones" class="common-empty-img mb-3" />
      <p class="common-empty-header">No Zones</p>
      <p class="common-empty-sub-text">Create zones to manage your seating arrangements.</p>
    </div>
  }
</div>
